import React from 'react'
import PropTypes from 'prop-types'
import NotificationCard from '../NotificationCard/NotificationCard'
import LoadingLayer from '../LoadingLayer/LoadingLayer'
import Text from '../Text/Text'

import styles from './notificationsList.scss'

const NotificationsAllPaginated = () => (
  <div className={styles.loaded}>
    <Text
      label="Você não tem mais notificações no momento"
      labelFontSize="12px"
      labelLineHeight="150%"
      color="#696977"
    />
  </div>
)

const NotificationsList = (props = {}) => {
  const {
    notifications,
    products,
    onClickAction,
    isLoading,
    isPaginationFinished,
    removeNegotiationById
  } = props

  const notificationsComponent = notifications.map((notification) => {
    const {
      notificationId,
      id,
      title,
      image,
      description,
      createdAt,
      interectedAt,
      readAt,
      productId,
      actions
    } = notification

    const productIndex = products.find((product) => product.id === productId)
    const { icon } = productIndex || {}
    const productIcon = icon

    // This is useful to update React's internal cache when `readAt` or `interectedAt` are updated
    const notificationKey = `${notificationId || id}_${readAt}_${interectedAt}`

    return (
      <NotificationCard
        notificationId={notificationId || id}
        key={notificationKey}
        title={title}
        image={image}
        description={description}
        createdAt={createdAt}
        interectedAt={interectedAt}
        readAt={readAt}
        productId={productId}
        actions={actions}
        productIcon={productIcon}
        onClickAction={onClickAction}
        removeNegotiationById={removeNegotiationById}
      />
    )
  })

  return (
    <div className={styles.list}>
      {notificationsComponent}

      {isLoading && (
        <div className={styles.isLoading}>
          <LoadingLayer active />
        </div>
      )}
      {isPaginationFinished && <NotificationsAllPaginated />}
    </div>
  )
}

NotificationsList.defaultProps = {
  onClickAction: null,
  isPaginationFinished: false,
  isLoading: false,
  notifications: [],
  products: [],
  removeNegotiationById: null
}

NotificationsList.propTypes = {
  onClickAction: PropTypes.func,
  isLoading: PropTypes.bool,
  isPaginationFinished: PropTypes.bool,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      createdAt: PropTypes.string,
      interectedAt: PropTypes.string,
      updatedAt: PropTypes.string,
      readAt: PropTypes.string,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          title: PropTypes.string,
          url: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        })
      )
    })
  ),
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.string,
      icon: PropTypes.string,
      hasNotification: PropTypes.bool
    })
  ),
  removeNegotiationById: PropTypes.func
}

export default NotificationsList
